export const REVIEW_WITH_AI_LABEL = 'Review with AI'

export const buildReviewPrompt = (fundRequestId: string | null | undefined) =>
  `What's wrong with my funding request ${fundRequestId ?? ''}? What can I do to fix it?`

export const buildWithdrawPrompt = (fundingApplicationId: string) =>
  `for funding application id: ${fundingApplicationId} cancel this funding request`

export const buildContactPdmPrompt = (fundingApplicationId: string) =>
  `for funding application id: ${fundingApplicationId} draft an email to pdm for wallet issues`
